import { IPlugin, IProjectPageParam, plugins } from "../../../common/businesslogic/index";
import { mDHF } from "../../../common/businesslogic/index";
import { ml } from "../../../common/matrixlib";
import { IReportOptions } from "../../../common/matrixlib/MatrixLibInterfaces";
import { SelectMode, ILinkType } from "../../../common/UI/Components/index";
import { ItemSelectionTools } from "../../../common/UI/Tools/ItemSelectionView";
import { IItem, globalMatrix, matrixSession, IReference, app, restConnection } from "../../../globals";

import { XRPostProject_LaunchReport_CreateReportJobAck } from "../../../RestResult";

export { initialize };

class Compare implements IPlugin {
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private _item: IItem;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private _jui: JQuery;
    public isDefault = true;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initItem(item: IItem, jui: JQuery) {
        this._item = item;
        this._jui = jui;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initServerSettings() {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initProject() {}
    async getProjectPagesAsync(): Promise<IProjectPageParam[]> {
        return [];
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    supportsControl() {
        return false;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    updateMenu(ul: JQuery) {
        let that = this;

        if (
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            !ml.Item.parseRef(this._item.id).isFolder &&
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            mDHF.isDocumentType(this._item.type) &&
            this._item.type !== "REPORT"
        ) {
            let extras = globalMatrix.ItemConfig.getExtrasConfig();

            if (
                extras &&
                (ml.JSON.isTrue(extras.compareX) || (extras.compareX === "admin" && matrixSession.isAdmin()))
            ) {
                let compareDocs = $('<li><a href="javascript:void(0)">Compare Docs</a></li>').click(function () {
                    let selectTools = new ItemSelectionTools();
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    let linkTypes: ILinkType[] = [{ type: that._item.type }];
                    let otherProject: string;

                    selectTools.showCrossProjectDialog({
                        linkTypes: linkTypes,
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        getSelectedItems: async function () {
                            return [{ to: that._item.id, title: "" }]; // same ID by default
                        },
                        selectionChange: function (newRefs: IReference[]) {
                            if (newRefs.length === 1) {
                                let signId = newRefs[0].to;
                                that.compareWith(otherProject, signId);
                            }
                        },
                        selectMode: SelectMode.singleItem,
                        crossProjectInit: function (psl: string) {
                            otherProject = psl;
                        },
                        crossProject: true,
                    });
                });
                ul.append(compareDocs);
            }
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private compareWith(toProject: string, toId: string) {
        let that = this;
        let reportProc: number;

        let ui = $("<div style='width:100%'>");
        ui.append(ml.UI.getSpinningWait("retrieving documents..."));

        let left: string;
        let right: string;

        // show dialog
        app.dlgForm.html("").append(ui);

        app.dlgForm.addClass("dlg-v-scroll");
        app.dlgForm.removeClass("dlg-no-scroll");

        app.dlgForm
            .dialog({
                autoOpen: true,
                title: "Compare documents",
                height: app.itemForm.height() * 0.9,
                width: $(document).width() * 0.9,
                modal: true,
                close: function () {
                    app.dlgForm.removeClass("forcePrint");
                    $(".compareTools").remove();
                },
                open: function () {
                    app.dlgForm.addClass("forcePrint");
                },
                resizeStop: function (event, ui) {
                    app.dlgForm.resizeDlgContent([]);
                },
                buttons: [
                    {
                        text: "Ok",
                        class: "btnCancelIt",
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        click: function () {
                            app.dlgForm.dialog("close");
                        },
                    },
                ],
            })
            .resizeDlgContent([], false);

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        app.startCreateDocumentAsync(this._item.id, { format: "html" }).done(function (
            result: XRPostProject_LaunchReport_CreateReportJobAck,
        ) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            mDHF.loadDocument(result.jobId, function (htmlDOM: any) {
                left = htmlDOM;
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                mDHF.compareDocumentsContent(that._item.id, toProject + ":" + toId, left, right, ui);
            });
        });
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        this.startCreateDocumentOtherProjectAsync(toProject, toId, { format: "html" }).done(function (
            result: XRPostProject_LaunchReport_CreateReportJobAck,
        ) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            mDHF.loadDocument(result.jobId, function (htmlDOM: any) {
                right = htmlDOM;
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                mDHF.compareDocumentsContent(that._item.id, toProject + ":" + toId, left, right, ui);
            });
        });
    }

    startCreateDocumentOtherProjectAsync(
        projectId: string,
        itemId: string,
        reportOptions: IReportOptions,
    ): JQueryDeferred<XRPostProject_LaunchReport_CreateReportJobAck> {
        let res: JQueryDeferred<XRPostProject_LaunchReport_CreateReportJobAck> = $.Deferred();
        reportOptions["url"] = globalMatrix.matrixBaseUrl;
        reportOptions["resturl"] = globalMatrix.matrixRestUrl;
        let isSign = mDHF.isSignedType(ml.Item.parseRef(itemId).type);
        restConnection
            .postServer(projectId + "/" + (isSign ? "signedreport/" : "report/") + itemId, reportOptions)
            .done(function (result) {
                res.resolve(result as XRPostProject_LaunchReport_CreateReportJobAck);
            });

        return res;
    }
}

// TODO: MATRIX-7555: lint errors should be fixed for next line
// eslint-disable-next-line
function initialize() {
    plugins.register(new Compare());
}
